export default __webpack_public_path__ + "static/media/brand.52d6c510.svg";